
import { useI18n } from 'vue-i18n'
import { defineComponent } from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { RootActions } from "@/store/actions";
import { RootGetters } from "@/store/getters";
import { LoginActions } from '@/modules/login/store/types';
import { productName } from "@/models/system-mode";

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: 'local'
    })
    return { t }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState(["config"]),
    ...mapGetters({
      systemMode: RootGetters.GET_SYSTEM_MODE,
      labeling: RootGetters.GET_LABELING,
    }),
    productName() {
      return productName[this.systemMode];
    },
  },
  methods: {
    ...mapActions({
      displayStatisticsScreen: RootActions.DISPLAY_STATISTICS_SCREEN,
    }),
    ...mapActions('loginModule', {
      logout: LoginActions.LOGOUT
    })
  },
});
